const imageSlider = {};


imageSlider.slider = function () {
	const $imageSlider = $('.js-image-slider');

	if ($imageSlider.length === 0) {
		return;
	}

	$.each($imageSlider, function () {
		const $slider = $(this);

		const flkty = $slider.flickity({
			cellAlign: 'center',
			wrapAround: true,
			dragThreshold: 10,
			prevNextButtons: false,
			pageDots: true,
		}).data('flickity');

		const $wrapper = $slider.closest('.image-slider-wrapper');
		const $prevBtn = $wrapper.find('.prev-btn');
		const $nextBtn = $wrapper.find('.next-btn');

		$prevBtn.on('click', function () {
			flkty.previous();
		});

		$nextBtn.on('click', function () {
			flkty.next();
		});
	});
}

imageSlider.init = function () {
	imageSlider.slider();
}

imageSlider.init();


// WEBPACK FOOTER //
// ./scripts/components/image-slider.js